
<template>
  <div class="container">
    <div class="right">
      <div class="flex-list">
        <div class="flex">
          <div>
            <el-input
              size="small"
              placeholder="请输入姓名"
              prefix-icon="el-icon-search"
              clearable
              v-model="users.keyword"
              @clear="clear"
            >
              <el-button
                slot="append"
                @click="handIput"
                :disabled="!users.keyword"
                >搜索</el-button
              >
            </el-input>
          </div>
        </div>
        <!-- <div>
          <el-button
            size="small"
            type="primary"
            icon="el-icon-plus"
            @click="centerDialogVisible = true"
            >添加成员
          </el-button>
        </div> -->
      </div>
      <div class="distance">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="name" label="姓名"> </el-table-column>
          <el-table-column prop="mobile" label="用户名"> </el-table-column>
          <el-table-column label="角色">
            <template slot-scope="scope">
              <div v-for="ite in scope.row.roles" :key="ite.id">
                {{ ite.name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="创建时间">
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <!-- <el-tooltip content="修改密码" placement="top">
                  <el-button
                    @click="handleClickPassword(scope.row)"
                    class="size"
                    type="text"
                    size="small"
                    icon="el-icon-edit"
                  ></el-button>
                </el-tooltip>  -->

              <!-- <el-tooltip content="编辑" placement="top">
                  <el-button
                    @click="handleClick(scope.row)"
                    class="size"
                    type="text"
                    size="small"
                    icon="el-icon-edit-outline"
                  ></el-button>
                </el-tooltip>
   -->
              <el-tooltip content="分配角色" placement="top">
                <el-button
                  @click="handleJurisdiction(scope.row)"
                  class="size"
                  type="text"
                  size="small"
                  icon="el-icon-s-tools"
                ></el-button>
              </el-tooltip>
              <!-- <el-tooltip content="删除" placement="top">
                  <el-button
                    type="text"
                    size="small"
                    @click="handLeButton(scope.row)"
                    class="size"
                    icon="el-icon-delete"
                    style="padding-left: 15px"
                  >
                  </el-button>
                </el-tooltip> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagingVue
        :Pagination="Pagination"
        :tableData="tableData"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pagingVue>

      <div>
        <!-- <el-dialog
            title="添加成员"
            :visible.sync="centerDialogVisible"
            width="30%"
            modal
            :close-on-click-modal="false"
            :show-close="false"
            destroy-on-close
            @close="close"
            append-to-body
          >
            <el-form
              class="login-form"
              label-position="top"
              label-width="80px"
              :model="useName"
              :rules="rules"
              ref="useName"
            >
              <el-form-item prop="name" label="姓名">
                <el-input
                  placeholder="请用户姓名"
                  v-model="useName.name"
                ></el-input>
              </el-form-item>
              <el-form-item prop="mobile" label="手机号">
                <el-input
                  placeholder="请输入手机号"
                  maxlength="11"
                  v-model.trim="useName.mobile"
                ></el-input>
              </el-form-item>
  
              <el-form-item prop="password" label="密码">
                <el-input
                  placeholder="请输入密码"
                    maxlength="16"
                  v-model.trim="useName.password"
                  show-password
                ></el-input>
              </el-form-item>
              <el-form-item prop="re_password" label="确认密码">
                <el-input
                  placeholder="请再次输入密码"
                   maxlength="16"
                  v-model.trim="useName.re_password"
                  show-password
                ></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="handCancel">取 消</el-button>
              <el-button type="primary" @click="handConfirm">确 定</el-button>
            </span>
          </el-dialog>
  
          <el-dialog
            title="编辑成员"
            :visible.sync="Popup"
            width="30%"
            modal
           :close-on-click-modal="false"
            :show-close="false"
            destroy-on-close
            @close="close"
            append-to-body
          >
            <el-form
              class="login-form"
              label-position="top"
              label-width="80px"
              :model="modify"
              :rules="rules"
              ref="modify"
            >
              <el-form-item prop="name" label="姓名">
                <el-input
                  placeholder="请输入用户姓名"
                  v-model="modify.name"
                ></el-input>
              </el-form-item>
              <el-form-item label="部门列表" prop="company_id">
                <el-select v-model="modify.company_id" placeholder="部门列表">
                  <el-option
                    v-for="(item, index) in dataList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="handClickCancel">取 消</el-button>
              <el-button type="primary" @click="handClickConfirm"
                >确 定</el-button
              >
            </span>
          </el-dialog> -->

        <!-- <el-dialog
            title="修改密码"
            :visible.sync="PopupMobel"
            width="30%"
            modal
             :close-on-click-modal="false"
            :show-close="false"
            destroy-on-close
            @close="close"
            append-to-body
          >
            <el-form
              class="login-form"
              label-position="top"
              label-width="80px"
              :model="modifymobel"
              :rules="rules"
              ref="modifymobel"
            >
                 <el-form-item prop="name" label="姓名">
                <el-input
                  placeholder="请用户姓名"
                  v-model="modifymobel.name"
                ></el-input>
              </el-form-item>
              <el-form-item prop="password" label="密码">
                <el-input
                  placeholder="请输入密码"
                  v-model.trim="modifymobel.password"
                   maxlength="16"
                  show-password
                ></el-input>
              </el-form-item>
              <el-form-item prop="re_password" label="确认密码">
                <el-input
                  placeholder="请再次输入密码"
                   maxlength="16"
                  v-model.trim="modifymobel.re_password"
                  show-password
                ></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="handClickCancel">取 消</el-button>
              <el-button type="primary" @click="handClickModifymobel"
                >确 定</el-button
              >
            </span>
          </el-dialog> -->
        <el-dialog
          title="分配角色"
          :visible.sync="PopupDiction"
          width="30%"
          modal
          :close-on-click-modal="false"
          :show-close="false"
          destroy-on-close
          @close="close"
          append-to-body
        >
          <el-form
            class="login-form"
            label-position="top"
            label-width="80px"
            :model="Roules"
            :rules="rules"
            ref="Roules"
          >
            <el-form-item label="角色" prop="role_ids">
              <el-select v-model="Roules.role_ids" placeholder="角色分配">
                <el-option
                  v-for="(item, index) in dataDiction"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="handClickCancel">取 消</el-button>
            <el-button type="primary" @click="handClickDiction"
              >确 定</el-button
            >
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
  <script>
import Navigationlist from "../../../components/Navigationlist/Navigationlist.vue";
import pagingVue from "../../../components/Paging/paging.vue";
export default {
  name: "Member_role",
  data() {
    // var mobilevalid = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error("手机号不能为空"));
    //   }
    //   let reg_tel =
    //     /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
    //   if (!reg_tel.test(value)) {
    //     return callback(new Error("请输入正确手机号"));
    //   } else {
    //     callback();
    //   }
    // };

    // var passwordvalid = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error("密码不能为空"));
    //   }
    //   if (value.length < 6) {
    //     return callback(new Error("密码长度不能少于6位"));
    //   }
    //   let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;
    //   if (!reg.test(value)) {
    //     return callback(new Error("请输入密码必须包含数字和字母"));
    //   } else {
    //     callback();
    //   }
    // };
    // var passwordvalidata = (rule, value, callback) => {
    //   if (!value) {
    //     callback(new Error("请再次输入密码"));
    //   }
    //   if (value.length < 6) {
    //     return callback(new Error("密码长度不能少于6位"));
    //   }
    //   if (value !== this.useName.password && value !== this.modifymobel.password) {
    //     callback(new Error("两次输入密码不一致!"));
    //   } else {
    //     callback();
    //   }
    // };

    return {
      mode: {
        id: "",
        name: "",
      },
      PopupMobel: false,
      flag: false,
      show: false,
      delete: {
        id: "",
      },
      active: "",
      dataList: [],
      ItemData: [],
      pupupTable: false,
      title: "",
      num: "",
      users: {
        keyword: "",
        page: "",
        company_id: "",
      },
      Pagination: {},
      useName: {
        name: "",
        mobile: "",
        password: "",
        re_password: "",
      },
      Roules: {
        user_id: "",
        role_ids: "",
      },
      modifymobel: {
        id: "",
        name: "",
        password: "",
        re_password: "",
      },
      modify: {
        id: "",
        name: "",
        company_id: null, //部门列表id
      },
      tableData: [],
      dataDiction: [], //角色列表
      // centerDialogVisible: false,
      PopupDiction: false,
      Popup: false,

      rules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          { min: 2, message: "长度至少2个字符", trigger: "blur" },
        ],
        // mobile: [{  required: true,validator: mobilevalid, trigger: "blur", trigger: "blur" }],
        role_ids: [{ required: true, message: "请分配角色", trigger: "blur" }],
        company_id: [
          { required: true, message: "请选择部门ID", trigger: "change" },
        ],
        // password: [
        //   {required: true, validator: passwordvalid, trigger: "blur", trigger: "blur" },
        // ],
        // re_password: [
        //   { required: true,validator: passwordvalidata, trigger: "blur", trigger: "blur" },
        // ],
      },
    };
  },
  components: {
    Navigationlist,
    pagingVue,
  },
  created() {
    this.rolesList();
  },
  // mounted() {
  //
  // },
  methods: {
    rolesList() {
      this.$axios
        .getListData("admin/users-with-role", this.users)
        .then((res) => {
          if (res.code === 200) {
            this.Pagination = res.data.meta.pagination;
            let time = res.data.data;
            this.tableData = time.map((v) => {
              return {
                ...v,
                created_at: this.$inserted(v.created_at),
              };
            });
          }
        });
    },

    //匹配成员
    handList(params) {
      let { item, id } = params;
      this.active = id.toString();
      this.users.company_id = id;
      this.active = id;
      this.users.name = null;
      this.rolesList();
    },

    close() {
      this.centerDialogVisible = false;
      this.useName = {};
      this.pupupTable = false;
      this.mode = {};
      this.PopupDiction = false;
    },
    handCancel() {
      this.centerDialogVisible = false;
      this.useName = {};
      this.pupupTable = false;
      this.mode = {};
      this.PopupDiction = false;
    },
    //搜索名字
    handIput() {
      this.users.page = "";
      this.users.company_id = "";
      this.rolesList();
    },
    clear() {
      this.users = {};
      this.rolesList();
    },
    // async handConfirm() {
    //   await this.$refs.useName.validate((valid) => {
    //     if (valid) {
    //       this.$axios
    //         .postListData("company/users", this.useName)
    //         .then((res) => {
    //           if (res.code === 200) {
    //             this.centerDialogVisible = false;
    //             this.useName = {};
    //             this.rolesList();
    //           }
    //         });
    //     } else {
    //       return false;
    //     }
    //   });
    // },
    //分配角色
    async handleJurisdiction(e) {
      console.log(e);
      this.$set(this.Roules, "role_ids", e.roles[0].id);
      this.PopupDiction = true;
      this.Roules.user_id = e.id;
      const res = await this.$axios.getListData("admin/roles");
      if ((res.code = 200)) {
        this.dataDiction = res.data;
      }
    },
    handClickDiction() {
      this.$refs.Roules.validate(async (valid) => {
        if (valid) {
          const res = await this.$axios.postListData(
            "admin/roles-user",
            this.Roules
          );
          if ((res.code = 200)) {
            this.rolesList();
            this.PopupDiction = false;
          }
        }
      });
    },
    // handleClickPassword(e) {
    //    this.$set(this.modifymobel, "name", e.name);
    //   this.modifymobel.id = e.id;
    //   this.PopupMobel = true;
    // },
    // handClickModifymobel() {
    //   this.$refs.modifymobel.validate(async (valid) => {
    //     if (valid) {
    //       this.$axios
    //         .postListData("company/update-user", this.modifymobel)
    //         .then((res) => {
    //           if (res.code === 200) {
    //             this.Popup = false;
    //             this.modifymobel = {};
    //             this.rolesList();
    //           }
    //         });
    //     }
    //   });
    // },

    // async handleClick(e) {
    //   const res = await this.$axios.getListData("company/companies");
    //   if (res.code == 200) {
    //     this.dataList = res.data;
    //   }
    //   this.$set(this.modify, "company_id", e.company.id);
    //   this.$set(this.modify, "name", e.name);
    //   this.modify.id = e.id;
    //   this.Popup = true;
    // },
    handClickCancel() {
      this.PopupMobel = false;
      this.PopupDiction = false;
      this.pupupTable = false;
      this.mode = {};
      this.modifymobel = {};
      this.Popup = false;
      this.modify = {};
    },
    // //编辑角色和部门
    // handClickConfirm() {
    //   this.$refs.modify.validate((valid) => {
    //     if (valid) {
    //       this.$axios
    //         .postListData("company/update-user", this.modify)
    //         .then((res) => {
    //           if (res.code === 200) {
    //             this.Popup = false;
    //             // this.users.company_id =""
    //             this.modify = {};
    //             this.rolesList();
    //           }
    //         });
    //     }
    //   });
    // },
    // handLeButton(e) {
    //   this.delete.id = e.id;

    //   this.$confirm("是否删除, 是否继续?", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning",
    //   })
    //     .then(() => {
    //       this.$axios
    //         .getListData("company/delete-user", this.delete)
    //         .then((res) => {
    //           if (res.code === 200) {
    //             if (this.tableData.length > 1) {
    //               this.rolesList();
    //             } else {
    //               if (this.users.page >= 2) {
    //                 this.users.page = this.users.page - 1;
    //                 this.rolesList();
    //               } else {
    //                 this.rolesList();
    //               }
    //             }
    //           }
    //         });
    //     })
    //     .catch(() => {});
    // },

    handleSizeChange(val) {},
    //分页
    handleCurrentChange(val) {
      this.users.page = val;
      this.rolesList();
    },
  },
};
</script>
  <style lang="less" scoped>
/deep/.cell {
  height: 28px !important;
}
/deep/.el-table__empty-text {
  line-height: 53px;
}
/deep/.el-table__empty-block {
  min-height: 53px;
}
/deep/.el-button--text {
  font-size: 18px;
  margin-top: -8px;
}
.dialog-footer {
  display: flex !important;
  justify-content: space-around !important;
}
/deep/.el-table__body {
  width: 100% !important;
}
/deep/.el-select {
  width: 100% !important;
}
.container {
  width: 100%;
  box-sizing: border-box;
  padding: 22px;
  overflow: hidden;
  display: flex;
  .distance {
    margin: 15px 0;
    padding: 0 20px;
  }
  .listdata {
    position: relative;
    margin: 20px 0;
    display: flex;
    box-sizing: border-box;
    padding: 0 20px;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
    height: 40px;

    color: #000;
    border-radius: 4px;
  }
  .icons {
    background-color: #409eff;
  }

  .background {
    background-color: rgba(34, 73, 192, 0.06);
  }

  .right {
    width: 100%;
    .flex-list {
      padding: 0 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .flex {
      display: flex;
      align-items: center;
    }
  }
}
</style>